function checkRigram(component, index, automation, targetStage, decisions, paths, sharedData, tempPath, cb) {
    let nullInputs = []
    for (const [key, path] of Object.entries(component.paths)) {
        // console.log('targetStage', targetStage)

        if (path.as == 'start') {
            if (automation.flow.paths[key].leadsToStage) {
                let found = false
                automation.flow.paths[key]?.leadsToStage?.map((element) => {
                    if (element.key == targetStage) {
                        found = true
                    }
                })
                if (found) {
                    nullInputs.push({ key: automation.flow.paths[path.key].ECKey, node: automation.flow.paths[path.key].ENKey, path: path.key })
                    if (automation.flow.paths[key].upcomingDecisions) {
                        automation.flow.paths[key].upcomingDecisions.map((element) => {
                            if (!decisions[element]) {
                                decisions[element] = { key: element }
                            }
                        })
                    }
                }
            }
            // else {
            //     nullInputs.push({ key: automation.flow.paths[path.key].ECKey, node: automation.flow.paths[path.key].ENKey, path: path.key })
            // }
        }
    }
    // console.log('nullInputs', nullInputs)
    if (nullInputs.length != 0) {
        // console.log('true20')
        findPaths(nullInputs, index, automation, targetStage, decisions, paths, sharedData, tempPath, () => {
            if (nullInputs[index + 1]) {
                // console.log('h1111a')
                index += 1
                // tempStage = trigger
                if (tempPath[tempPath.length - 1].key == targetStage) {
                    paths.push([...tempPath])
                }
                tempPath.pop()
                checkRigram(component, index, automation, targetStage, decisions, paths, sharedData, tempPath, () => {
                    cb()
                })
            }
            else {
                tempPath.pop()
                cb()
            }
        })
    }
    else {
        // console.log('tempPath2', [...tempPath])
        if (tempPath.length != 0 && tempPath[tempPath.length - 1].key == targetStage) {
            paths.push([...tempPath])
        }
        // console.log('last tp sharedData', sharedData)
        cb()
    }
}
function findPaths(componentQueue, index, automation, targetStage, decisions, paths, sharedData, tempPath, cb) {
    if (componentQueue[index]) {

        let component = automation.flow.components[componentQueue[index].key]
        // console.log('componentQueue[index]', component.type)
        if (component.type == 'condition') {
            sharedData.condition = true
        }
        // console.log(sharedData)
        tempPath.push(componentQueue[index])

        checkRigram(component, 0, automation, targetStage, decisions, paths, sharedData, tempPath, () => {
            cb()
        })
    }
    else {
        if (tempPath[tempPath.length - 1].key == targetStage) {
            paths.push([...tempPath])
        }
        cb()
        // findPaths(componentQueue, index + 1, automation, targetStage, path, allPaths, () => {
        //     console.log('dodk')
        // })
    }
}
export { findPaths, checkRigram }
